export default __webpack_public_path__ + "static/privacy-c767669d9b6ae40180c82d6cb4bb98ac.png";